
import React from 'react';
import { Link } from 'react-router-dom';
import "contents/assets/scss/page/member.scss";

function SearchId() {
  return (
    <main className='com_member p_searchId'>
      <div className='box'>
        <h2 className='title'>아이디 찾기</h2>
        <ul className='com_input_sec'>
          <li className='tit_field'>전화번호 인증하기</li>
          <li className='input_field'>
            <div className="com_input_wrap flex_row">
              <input type='text' placeholder='-없이 전화번호 입력'/>
              <button className="com_btn gray m">인증번호 요청</button>
            </div>
            <span className="error_txt">* 전화번호 형식이 정확하지 않습니다.</span>
          </li>
          <li className='tit_field'>발송된 인증번호를 입력해 주세요.</li>
          <li className='input_field'>
            <div className="com_input_wrap flex_row">
              <input type='text' placeholder='인증번호 입력'/>
              <button className="com_btn gray m">확인</button>
            </div>
            <span className="error_txt">* 인증번호가 정확하지 않습니다.</span>
          </li>
        </ul>
        <div className="txt_box">
          회원님의 이메일 아이디는 <br />
          <strong className="id">exam***@naver.com</strong>
        </div>
        <section className='com_btn_wrap'>
          <Link to="/Member/Login" className='com_btn orange m full bold'>로그인 페이지 이동하기</Link>
          <Link to="/Member/SearchPw" className='com_btn lightGray m full'>비밀번호 찾기</Link>
        </section>
      </div>
    </main>
  );
}

export default SearchId;
